import { projectsSchema } from "@companies/shared/types/project";

import { FETCH_ERROR } from "../consts/fetch-error";

const API_BASE_URL = process.env.API_BASE_URL || "/api";

export async function getProjects() {
  const response = await fetch(`${API_BASE_URL}/project`);

  if (response.status === 401) {
    throw FETCH_ERROR.UNAUTHORIZED;
  } else if (!response.ok) {
    throw new Error("Failed to get projects");
  }

  return projectsSchema.parse(await response.json());
}
